'use client'

import React from "react";
import { useSelector } from "react-redux";

function AboutStylitCard() {
  const language = useSelector((state) => state.language.language);

  const text = {
    subTitle:
      language === "en"
        ? "Door To Door Beauty Provides"
        : "घर पर ब्यूटी पार्लर और सैलून सेवा",
    titleFirst:
      language === "en"
        ? "Highly Trained & Certified professionals At"
        : "घर पर ब्यूटी पार्लर और सैलून सेवा",
    titleSecond: language === "en" ? "Your Home" : "",
    description:
      language === "en"
        ? "Step into a world of luxury and convenience with Door To Door Beauty. We bring the salon experience to your doorstep, offering highly trained and certified professionals ready to pamper you in the comfort of your own home. Whether it's a rejuvenating facial, a flawless manicure, or a relaxing massage, our expert team ensures top-notch services tailored to your needs."
        : "हमारा मिशन सैलून उद्योग में क्रांति लाना है, जहां हम अपने कुशल पेशेवरों की पहुंच को बढ़ाकर और बेजोड़ सेवाएं सीधे आपके घर पर प्रदान करके, एक ऐसा अनुभव देते हैं जैसा पहले कभी नहीं हुआ।",
  };

  return (
    <div className="block mx-auto max-w-screen-2xl">
      <div className="mx-auto max-w-screen-2xl px-4 sm:px-10">
        <div className="lg:p-2 p-2 rounded-lg">
          <div className="w-full bg-white shadow-sm lg:px-10 lg:py-5 p-6 rounded-lg">
            {/* FLEX CONTAINER */}
            <div className="flex flex-col-reverse lg:flex-row justify-between items-center gap-6">
              {/* TEXT SECTION */}
              <div className="w-full lg:w-3/5">
                <span cclassName="text-3xl md:text-4xl lg:text-2xl font-bold mb-1">
                {text.subTitle}
                </span>

                <h2
                    style={{
                      fontSize: "1.4rem",
                      color: "#000000",
                      fontFamily: "Roboto, sans-serif",
                    }}
                    className="text-lg lg:text-2xl font-bold mb-1"
                  >
                    {text.titleFirst}{" "}
                    <span className="text-pink-600">{text.titleSecond}</span>
                  </h2>

                <p className="text-base lg:text-lg leading-relaxed text-justify text-gray-700">
                  {text.description}
                </p>

                {/* Optional Button */}
                {/* 
                <Link
                  className="inline-block mt-5 px-8 py-3 bg-pink-600 text-white rounded-full hover:bg-emerald-600 text-sm font-semibold transition"
                  href="#"
                >
                  Book Now
                </Link> 
                */}
              </div>

              {/* IMAGE SECTION */}
              <div className="w-full lg:w-2/5 flex justify-center">
                <img
                  loading="lazy"
                  src="/assets/AppImage/appImage3.png"
                  alt="About us Beauty Service"
                  className="max-w-full h-auto object-contain rounded-md shadow-md"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutStylitCard;
